import { GitCommit } from '../models/git-worker.model';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitLogAction extends WorkerAction {
  type: GitAction.Log;
  params?: string[];
}

export class GitLogActionError extends WorkerActionError {}

// git hash-object -t tree /dev/null
export const EMPTY_TREE_SHA1 = '4b825dc642cb6eb9a060e54bf8d69288fbee4904';

export async function GitLogActionFn({ lg, params }: WorkerFnParams<GitLogAction>): Promise<GitCommit[]> {
  try {
    const output = lg.callAndCaptureOutput(['log', ...(params || [])]);
    const commits: GitCommit[] = [];
    const lines = output.split('\n');
    let commit: GitCommit | null = null;
    /**
     * commit b588747e4e0194d09561b0dd47e9393e07b63feb
     * Merge: b588747 b731930
     * Author: FirstName LastName <user@email.com>
     * Date:   Tue Dec  7 21:21:36 2021 +0300
     *
     * Update metadata.json
     */
    for (const line of lines) {
      if (line.startsWith('commit ')) {
        // commit b588747e4e0194d09561b0dd47e9393e07b63feb
        const hash = /commit (.+)/.exec(line)![1];
        if (commit) {
          commit.description = commit.description.trim();
          commits.push(commit);
        }
        commit = {
          hash,
          description: '',
        } as GitCommit;
      } else if (commit && line.startsWith('Author:')) {
        // Author: FirstName LastName <user@email.com>
        const parseResult = /Author: (.+) <(.+)>/.exec(line)!;
        commit.authorName = parseResult[1] ?? '';
        commit.authorEmail = parseResult[2] ?? '';
      } else if (commit && line.startsWith('Date:')) {
        // Date:   Tue Dec  7 21:21:36 2021 +0300
        commit.date = new Date(/Date: (.+)/.exec(line)?.[1]?.trim() ?? '');
      } else if (commit && line.startsWith('Merge:')) {
        commit.isMergeCommit = true;
      } else if (commit && line.trim()) {
        if (!commit.title) {
          commit.title = line.trim();
        } else {
          commit.description += `${line.trim()}\n`;
        }
      }
    }
    if (commit) {
      commit.description = commit.description.trim();
      commits.push(commit);
    }

    return await Promise.all(
      commits.map(async (item) => {
        let parentHash = '';
        try {
          parentHash = lg.callAndCaptureOutput(['rev-parse', `${item.hash}^`]);
        } catch (err) {
          // root commit
          parentHash = EMPTY_TREE_SHA1;
        }

        return {
          ...item,
          parentHash,
        };
      }),
    );
  } catch (err) {
    throw new GitLogActionError(err);
  }
}
